/* Afkar Plus — product page v1: gallery, option pills, qty, add to bag, WhatsApp link, free-delivery bar (live cart),
   simulated live viewers, and the proof poppers (real reviews / real orders from blocks; one slot, alternating).
   (BeyondADS, 23 Sep 2026) */
(function () {
  'use strict';
  if (window.__apLoaded) return;
  window.__apLoaded = true;

  var routes = window.routes || {};
  var ADD = (routes.cart_add_url || '/cart/add') + '.js';
  var CART = (routes.cart_url || '/cart') + '.js';

  function money(sym, cents) { return sym + (cents / 100).toFixed(2); }
  function paintBubble(sections) {
    var html = sections && sections['cart-icon-bubble'];
    var el = document.getElementById('cart-icon-bubble');
    if (!html || !el) return;
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var inner = doc.querySelector('.shopify-section');
    el.innerHTML = inner ? inner.innerHTML : html;
  }
  function addItems(items) {
    return fetch(ADD, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: items, sections: 'cart-icon-bubble' }) })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, body: j }; }); })
      .then(function (res) {
        if (!res.ok) throw new Error(res.body && (res.body.description || res.body.message) || 'Could not add to the cart');
        paintBubble(res.body && res.body.sections);
        document.dispatchEvent(new CustomEvent('afkar:cart:updated', { detail: { items: items } }));
        return res.body;
      });
  }
  function flash(el, cls, ms) { el.classList.add(cls); setTimeout(function () { el.classList.remove(cls); }, ms); }
  function rand(a, b) { return a + Math.floor(Math.random() * (b - a + 1)); }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function ago(iso) {
    var t = Date.parse(iso); if (!t) return '';
    var m = Math.max(1, Math.round((Date.now() - t) / 60000));
    if (m < 60) return m + ' min ago';
    var h = Math.round(m / 60); if (h < 24) return h + (h === 1 ? ' hour ago' : ' hours ago');
    var d = Math.round(h / 24); if (d < 7) return d + (d === 1 ? ' day ago' : ' days ago');
    var w = Math.round(d / 7); if (w < 5) return w + (w === 1 ? ' week ago' : ' weeks ago');
    return 'recently';
  }

  function init(root) {
    if (root.__ap) return;
    root.__ap = true;
    var sym = root.getAttribute('data-currency') || '$';

    /* ---------- gallery ---------- */
    var slides = Array.prototype.slice.call(root.querySelectorAll('[data-ap-slide]'));
    var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-ap-thumb]'));
    var cur = root.querySelector('[data-ap-cur]');
    var gi = 0;
    function showSlide(k) {
      if (!slides.length) return;
      gi = ((k % slides.length) + slides.length) % slides.length;
      slides.forEach(function (s, j) { var on = j === gi; s.classList.toggle('is-active', on); s.hidden = !on; });
      thumbs.forEach(function (t, j) { t.classList.toggle('is-active', j === gi); });
      if (cur) cur.textContent = gi + 1;
      var t = thumbs[gi]; if (t && t.scrollIntoView) { try { t.scrollIntoView({ block: 'nearest', inline: 'nearest' }); } catch (e) {} }
    }
    function showMedia(id) { var k = slides.findIndex(function (s) { return s.getAttribute('data-media-id') === String(id); }); if (k >= 0) showSlide(k); }
    root.addEventListener('click', function (e) {
      var t = e.target.closest('[data-ap-thumb]'); if (t) { showSlide(parseInt(t.getAttribute('data-ap-thumb'), 10)); return; }
      if (e.target.closest('[data-ap-prev]')) { showSlide(gi - 1); return; }
      if (e.target.closest('[data-ap-next]')) { showSlide(gi + 1); return; }
    });
    var touchX = null, stage = root.querySelector('.ap-stage');
    if (stage) {
      stage.addEventListener('touchstart', function (e) { touchX = e.touches[0].clientX; }, { passive: true });
      stage.addEventListener('touchend', function (e) { if (touchX == null) return; var dx = e.changedTouches[0].clientX - touchX; touchX = null; if (Math.abs(dx) > 40) showSlide(gi + (dx < 0 ? 1 : -1)); }, { passive: true });
    }

    /* ---------- options / variant ---------- */
    var variants = [];
    try { var vj = root.querySelector('[data-ap-variants]'); if (vj) variants = JSON.parse(vj.textContent); } catch (e) { variants = []; }
    var current = { id: parseInt(root.getAttribute('data-variant'), 10), price: parseInt(root.getAttribute('data-price'), 10) || 0, available: true };
    var opts = Array.prototype.slice.call(root.querySelectorAll('[data-ap-opt]'));
    var chosen = opts.map(function (o) { var a = o.querySelector('.ap-pill.is-active'); return a ? a.getAttribute('data-ap-pill') : null; });
    function find(sel) { return variants.find(function (v) { return v.options.every(function (o, j) { return o === sel[j]; }); }); }
    function applyVariant(v) {
      current = { id: v.id, price: v.price, available: v.available };
      root.setAttribute('data-variant', v.id); root.setAttribute('data-price', v.price);
      var now = root.querySelector('[data-ap-now]'), was = root.querySelector('[data-ap-was]');
      if (now) now.textContent = money(sym, v.price);
      if (was) { if (v.compare > v.price) { was.textContent = money(sym, v.compare); was.hidden = false; } else was.hidden = true; }
      var add = root.querySelector('[data-ap-add]');
      if (add) { add.disabled = !v.available; add.querySelector('.ap-btn__label').textContent = v.available ? add.getAttribute('data-label') : 'Sold out'; }
      if (v.media) showMedia(v.media);
      opts.forEach(function (o, j) { var lab = o.querySelector('[data-ap-optval]'); if (lab) lab.textContent = chosen[j]; o.querySelectorAll('.ap-pill').forEach(function (b) { b.classList.toggle('is-active', b.getAttribute('data-ap-pill') === chosen[j]); }); });
      markOut();
      updateBar();
      try { history.replaceState(null, '', location.pathname + '?variant=' + v.id); } catch (e) {}
    }
    // grey out (strike through) values that give no purchasable variant with the other choices held - on load too, not only after a click
    function markOut() {
      if (!variants.length) return;
      opts.forEach(function (o, j) {
        o.querySelectorAll('.ap-pill').forEach(function (b) {
          var trial = chosen.slice(); trial[j] = b.getAttribute('data-ap-pill');
          var vv = find(trial), out = !vv || !vv.available;
          b.classList.toggle('is-out', out);
          if (out) b.setAttribute('title', 'Sold out'); else b.removeAttribute('title');
        });
      });
    }
    markOut();
    var addBtn = root.querySelector('[data-ap-add]');
    if (addBtn) addBtn.setAttribute('data-label', addBtn.querySelector('.ap-btn__label').textContent);
    root.addEventListener('click', function (e) {
      var pill = e.target.closest('[data-ap-pill]'); if (!pill) return;
      var j = parseInt(pill.closest('[data-ap-opt]').getAttribute('data-ap-opt'), 10);
      chosen[j] = pill.getAttribute('data-ap-pill');
      var v = find(chosen);
      if (!v) { // slide the other options to the nearest purchasable combination
        var cand = variants.find(function (x) { return x.available && x.options[j] === chosen[j]; }) || variants.find(function (x) { return x.options[j] === chosen[j]; });
        if (cand) { chosen = cand.options.slice(); v = cand; }
      }
      if (v) applyVariant(v);
    });

    /* ---------- sticky gallery offset = sticky header height ---------- */
    function stick() {
      var h = document.querySelector('.shopify-section-header, .section-header, .header-wrapper, header');
      var off = 0;
      if (h) { var cs = getComputedStyle(h); if (cs.position === 'sticky' || cs.position === 'fixed') off = h.getBoundingClientRect().height; }
      root.style.setProperty('--ap-stick', Math.round(off) + 'px');
    }
    stick(); window.addEventListener('resize', stick); setTimeout(stick, 1200);

    /* ---------- quantity ---------- */
    var qty = root.querySelector('[data-ap-qty]');
    function getQty() { return Math.max(1, parseInt(qty && qty.value, 10) || 1); }
    root.addEventListener('click', function (e) {
      if (e.target.closest('[data-ap-minus]')) { qty.value = Math.max(1, getQty() - 1); updateBar(); }
      if (e.target.closest('[data-ap-plus]')) { qty.value = getQty() + 1; updateBar(); }
    });
    if (qty) qty.addEventListener('change', function () { qty.value = getQty(); updateBar(); });

    /* ---------- WhatsApp: message carries the product + link ---------- */
    var wa = root.querySelector('[data-ap-wa]');
    if (wa) {
      var text = 'Hi Afkar Plus! I would like to order: ' + root.getAttribute('data-title') + ' — ' + root.getAttribute('data-url');
      wa.setAttribute('href', 'https://wa.me/' + root.getAttribute('data-wa') + '?text=' + encodeURIComponent(text));
    }

    /* ---------- free-delivery bar: mirrors the REAL cart only (same numbers as the cart drawer), live ---------- */
    var bar = root.querySelector('[data-ap-bar]');
    var threshold = parseInt(root.getAttribute('data-threshold'), 10) || 0;
    var cartSubtotal = 0;
    var copyTpl = bar ? bar.querySelector('[data-ap-barcopy]').getAttribute('data-tpl') : '';
    var gift = parseInt(root.getAttribute('data-gift'), 10) || 0;
    function updateBar() {
      if (!bar || !threshold) return;
      var total = cartSubtotal;
      var pct = Math.max(0, Math.min(100, total / threshold * 100));
      bar.querySelector('[data-ap-barfill]').style.width = pct + '%';
      var copy = bar.querySelector('[data-ap-barcopy]');
      Array.prototype.forEach.call(bar.querySelectorAll('[data-ap-stop]'), function (s) {
        s.classList.toggle('is-hit', total >= (parseInt(s.getAttribute('data-amount'), 10) || 0));
      });
      bar.classList.remove('is-done');
      if (total >= threshold) { copy.textContent = bar.getAttribute('data-done'); bar.classList.add('is-done'); }
      else if (gift && gift < threshold && total >= gift) { copy.textContent = (bar.getAttribute('data-mid') || bar.getAttribute('data-copy')).replace('{amount}', money(sym, threshold - total)); }
      else if (gift && gift < threshold) { copy.textContent = (bar.getAttribute('data-copy-gift') || bar.getAttribute('data-copy')).replace('{amount}', money(sym, gift - total)); }
      else { copy.textContent = bar.getAttribute('data-copy').replace('{amount}', money(sym, threshold - total)); }
    }
    var readSeq = 0;
    function readCart() {
      var mine = ++readSeq;
      return fetch(CART, { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); })
        .then(function (c) { if (mine !== readSeq) return; cartSubtotal = c.items_subtotal_price || 0; updateBar(); }).catch(function () { updateBar(); });
    }
    if (bar) {
      var copyEl = bar.querySelector('[data-ap-barcopy]');
      bar.setAttribute('data-copy', bar.getAttribute('data-copy') || copyEl.getAttribute('data-copy-tpl') || copyEl.textContent);
      readCart();
      document.addEventListener('afkar:cart:updated', readCart);
      /* the cart drawer app changes the cart on its own (remove, +/-): catch every cart write, fetch or XHR */
      var soon = null;
      function later() { clearTimeout(soon); soon = setTimeout(readCart, 350); }
      var CARTW = /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/;
      if (window.fetch && !window.fetch.__apBar) {
        var of = window.fetch;
        var wf = function (input) {
          var p = of.apply(this, arguments);
          try { var u = typeof input === 'string' ? input : (input && input.url) || ''; if (CARTW.test(u)) p.then(later, later); } catch (e) {}
          return p;
        };
        wf.__apBar = true; wf.__aof = of.__aof; window.fetch = wf;
      }
      if (window.XMLHttpRequest && !XMLHttpRequest.prototype.__apBar) {
        var oo = XMLHttpRequest.prototype.open;
        XMLHttpRequest.prototype.open = function (m, u) {
          try { if (CARTW.test(String(u))) this.addEventListener('loadend', later); } catch (e) {}
          return oo.apply(this, arguments);
        };
        XMLHttpRequest.prototype.__apBar = true;
      }
      document.addEventListener('visibilitychange', function () { if (!document.hidden) readCart(); });
      window.addEventListener('pageshow', function (e) { if (e.persisted) readCart(); });
    }

    /* ---------- add to bag / pair add ---------- */
    root.addEventListener('click', function (e) {
      var add = e.target.closest('[data-ap-add]');
      if (add && !add.classList.contains('is-busy') && !add.disabled) {
        e.preventDefault();
        var msg = root.querySelector('[data-ap-msg]'); if (msg) { msg.hidden = true; msg.textContent = ''; }
        add.classList.add('is-busy');
        addItems([{ id: current.id, quantity: getQty() }])
          .then(function () { flash(add, 'is-added', 2200); })
          .catch(function (err) { if (msg) { msg.textContent = err.message || 'Could not add to the cart'; msg.hidden = false; setTimeout(function () { msg.hidden = true; }, 4000); } })
          .then(function () { add.classList.remove('is-busy'); });
        return;
      }
      var pa = e.target.closest('[data-ap-pairadd]');
      if (pa && !pa.classList.contains('is-busy')) {
        e.preventDefault(); e.stopPropagation();
        pa.classList.add('is-busy');
        addItems([{ id: parseInt(pa.getAttribute('data-variant'), 10), quantity: 1 }])
          .then(function () { flash(pa, 'is-added', 1600); })
          .catch(function (err) { pa.setAttribute('title', err.message || 'Could not add to the cart'); })
          .then(function () { pa.classList.remove('is-busy'); });
      }
    });

    /* ---------- live viewers (simulated: seeded per product, drifts by ±1) ---------- */
    var viewers = root.querySelector('[data-ap-viewers]');
    if (viewers) {
      var vmin = parseInt(root.getAttribute('data-viewers-min'), 10) || 4, vmax = parseInt(root.getAttribute('data-viewers-max'), 10) || 16;
      var seed = parseInt(root.getAttribute('data-seed'), 10) || 1;
      var n = vmin + (seed % Math.max(1, vmax - vmin + 1));
      viewers.textContent = n;
      setInterval(function () {
        if (document.hidden) return;
        n = Math.max(vmin, Math.min(vmax, n + (Math.random() < 0.5 ? -1 : 1)));
        viewers.textContent = n; flash(viewers, 'is-tick', 500);
      }, rand(7000, 13000));
    }

    /* ---------- poppers: real reviews + real orders, one slot, alternating, dismiss = skip this one ---------- */
    var pop = root.querySelector('[data-ap-pop]');
    var reviews = [], sales = [];
    try { reviews = JSON.parse(root.querySelector('[data-ap-reviews]').textContent).filter(function (r) { return r.quote; }); } catch (e) {}
    try { sales = JSON.parse(root.querySelector('[data-ap-sales]').textContent).filter(function (s) { return s.product; }); } catch (e) {}
    if (pop && (reviews.length || sales.length)) {
      var first = (parseInt(pop.getAttribute('data-first'), 10) || 5) * 1000;
      var dwell = (parseInt(pop.getAttribute('data-dwell'), 10) || 7) * 1000;
      var gap = (parseInt(pop.getAttribute('data-gap'), 10) || 12) * 1000;
      var body = pop.querySelector('[data-ap-popbody]');
      var ri = 0, si = 0, kind = reviews.length ? 'review' : 'sale', busy = false, hideTimer = null;
      function stars(n) { var s = ''; for (var i = 1; i <= 5; i++) s += '<svg viewBox="0 0 24 24" class="' + (i <= n ? 'is-on' : '') + '"><path d="M12 2.6l2.9 6.1 6.7.8-4.9 4.6 1.3 6.6L12 17.4l-6 3.3 1.3-6.6L2.4 9.5l6.7-.8z"/></svg>'; return s; }
      function card() {
        if (kind === 'review' && reviews.length) {
          var r = reviews[ri++ % reviews.length];
          return '<a class="ap-pop__card ap-pop__card--review" href="' + esc(r.url || '#') + '">' + (r.image ? '<img class="ap-pop__img" src="' + esc(r.image) + '" alt="">' : '') + '<span class="ap-pop__text"><span class="ap-pop__stars">' + stars(r.stars) + '</span><span class="ap-pop__quote">“' + esc(r.quote) + '”</span><span class="ap-pop__meta">' + esc(r.name) + (r.product ? ' · ' + esc(r.product) : '') + '</span></span></a>';
        }
        var s = sales[si++ % sales.length];
        return '<a class="ap-pop__card ap-pop__card--sale" href="' + esc(s.url || '#') + '">' + (s.image ? '<img class="ap-pop__img" src="' + esc(s.image) + '" alt="">' : '') + '<span class="ap-pop__text"><span class="ap-pop__lead">Someone in ' + esc(s.city || 'Lebanon') + ' bought</span><span class="ap-pop__prod">' + esc(s.product) + '</span><span class="ap-pop__meta">' + esc(ago(s.when) || 'recently') + '</span></span></a>';
      }
      function next() { kind = (kind === 'review' && sales.length) ? 'sale' : (reviews.length ? 'review' : 'sale'); }
      function hide() { pop.classList.remove('is-in'); busy = false; clearTimeout(hideTimer); setTimeout(function () { if (!busy) pop.hidden = true; }, 350); next(); setTimeout(show, gap); }
      function show() {
        if (busy) return;
        if (document.hidden) { setTimeout(show, 3000); return; }
        busy = true; body.innerHTML = card(); pop.hidden = false;
        requestAnimationFrame(function () { requestAnimationFrame(function () { pop.classList.add('is-in'); }); });
        hideTimer = setTimeout(hide, dwell);
      }
      pop.querySelector('[data-ap-popx]').addEventListener('click', function (e) { e.preventDefault(); hide(); });
      setTimeout(show, first);
      root.__apPopShow = show;
    }

    showSlide(0);
    root.__apShow = showSlide;
  }

  function boot() { document.querySelectorAll('[data-ap]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
